/** 用户管理路由 */
export default {
    name: 'auth',
    path: 'userManage',
    meta: {
        title: '用户管理'
    },
    component: () => import('@/pages/index.vue'),
    children: [
        {
            name: 'auth-user',
            path: 'personal',
            meta: { title: '个人' },
            component: () => import('@/pages/userManage/personal.vue')
        },
        {
            name: 'auth-enterprise',
            path: 'enterprise',
            meta: { title: '企业' },
            component: () => import('@/pages/userManage/enterprise.vue')
        },
        {
            name: 'auth-pending-enterprise',
            path: 'pendingEnterprise',
            meta: { title: '待认证企业' },
            component: () => import('@/pages/userManage/pendingEnterprise.vue')
        }
    ]
}

